export default __webpack_public_path__ + "static/radovi8-42c1edc242bd4c2b3ea584254952c751.png";